module.exports = __webpack_public_path__ + "static/img/cio.d6f10385.png";